import { render, staticRenderFns } from "./ownerCommitteeManageList.vue?vue&type=template&id=fda0869a&scoped=true"
import script from "./ownerCommitteeManageList.vue?vue&type=script&lang=js"
export * from "./ownerCommitteeManageList.vue?vue&type=script&lang=js"
import style0 from "./ownerCommitteeManageList.vue?vue&type=style&index=0&id=fda0869a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda0869a",
  null
  
)

export default component.exports